import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "mb-fee-portal/:userId",
    component: withAsyncRouteLoading(() =>
      Promise.all([
        import(/* webpackChunkName: "mb-fee-portal" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    ),
    childRoutes: [],
  };
};
